// extracted by mini-css-extract-plugin
module.exports = {"section":"J_section__uFNP1"};